import { ERRORS, nextLabel, pct, plural, whenLabel } from '../format';
import { useApp } from '../store';
import { btn, ellipsis, mono, panelCol, sectionTitle } from '../ui';

const SCHED_GRID = '1.4fr 1fr 1fr 1fr auto';
const HIST_GRID = '118px 1fr 190px 96px';

export function Tasks() {
  const app = useApp();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <section style={{ ...panelCol, gap: 12 }}>
        <span style={sectionTitle}>Расписание</span>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: SCHED_GRID,
            gap: 14,
            paddingBottom: 10,
            borderBottom: '1px solid var(--line)',
            fontSize: 11,
            color: 'var(--ink3)'
          }}
        >
          <span>Задача</span>
          <span>Цель</span>
          <span>Расписание</span>
          <span>Следующий запуск</span>
          <span>Статус</span>
        </div>

        {app.schedule.map(t => {
          const paused = t.state === 'paused';
          return (
            <div
              key={t.id}
              style={{
                display: 'grid',
                gridTemplateColumns: SCHED_GRID,
                gap: 14,
                padding: '4px 0',
                alignItems: 'baseline',
                fontSize: 12.5
              }}
            >
              <span style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                <span style={{ fontWeight: 500 }}>{t.name}</span>
                <button
                  onClick={() => void app.runTask(t.id)}
                  title="Запустить прямо сейчас"
                  style={{ ...btn, fontSize: 11, color: 'var(--acc)' }}
                >
                  запустить
                </button>
              </span>
              <span style={{ ...mono, fontSize: 11.5, color: 'var(--ink3)' }}>{t.target}</span>
              <span style={{ ...mono, fontSize: 11.5, color: 'var(--ink2)' }}>{t.cron}</span>
              <span style={{ ...mono, fontSize: 11.5, color: 'var(--ink2)' }}>{nextLabel(t.nextRun)}</span>
              <button
                onClick={() => void app.setTaskState(t.id, paused ? 'active' : 'paused')}
                title={paused ? 'Включить задачу' : 'Поставить на паузу'}
                style={{
                  ...btn,
                  fontSize: 11.5,
                  padding: '3px 10px',
                  borderRadius: 99,
                  background: paused ? 'var(--badSoft)' : 'var(--accSoft)',
                  color: paused ? 'var(--warn)' : 'var(--ok)'
                }}
              >
                {paused ? 'пауза' : 'активна'}
              </button>
            </div>
          );
        })}

        {!app.schedule.length && (
          <span style={{ fontSize: 12.5, color: 'var(--ink3)' }}>Расписание пусто.</span>
        )}
      </section>

      <section style={{ ...panelCol, gap: 12 }}>
        <span style={sectionTitle}>История выполнения</span>

        {app.jobs.map(j => {
          const partial = j.err > 0;
          const color = j.state === 'cancelled' ? 'var(--ink4)' : partial ? 'var(--warn)' : 'var(--ok)';
          const state =
            j.state === 'running'
              ? 'идёт'
              : j.state === 'cancelled'
                ? 'отменено'
                : partial
                  ? 'частично'
                  : 'завершено';
          return (
            <div
              key={j.id}
              title={j.err ? `${plural(j.err, ERRORS)} из ${j.total}` : undefined}
              style={{
                display: 'grid',
                gridTemplateColumns: HIST_GRID,
                gap: 16,
                padding: '10px 0',
                borderBottom: '1px solid var(--line)',
                alignItems: 'center'
              }}
            >
              <span style={{ ...mono, fontSize: 11, color: 'var(--ink3)' }}>{whenLabel(j.createdAt)}</span>
              <span style={{ ...mono, fontSize: 12, ...ellipsis }}>{j.cmd}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ flex: 1, display: 'block', height: 5, borderRadius: 99, background: 'var(--track)' }}>
                  <span
                    style={{
                      display: 'block',
                      height: 5,
                      borderRadius: 99,
                      background: color,
                      width: pct(j.ok, j.total)
                    }}
                  />
                </span>
                <span style={{ ...mono, fontSize: 11, color: 'var(--ink2)' }}>
                  {j.ok}/{j.total}
                </span>
              </span>
              <span style={{ fontSize: 11.5, textAlign: 'right', color }}>{state}</span>
            </div>
          );
        })}

        {!app.jobs.length && (
          <span style={{ fontSize: 12.5, color: 'var(--ink3)' }}>
            Массовых операций ещё не запускали.
          </span>
        )}
      </section>
    </div>
  );
}
